export default __webpack_public_path__ + "static/media/eventModule.1d08ec93.svg";